import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Colors } from "../../helpers/Colors";
import { useDispatch, useSelector } from "react-redux";
import jwt_decode from "jwt-decode";
import { setToken } from "../../redux/Features/Token/TokenSlice";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ax_login } from "../../api/auth";

const useStyles = makeStyles({
  Home: {
    backgroundColor: Colors.primaryExtraLight2,
    width: "auto",
    // height: "100vh",
    overflow: "auto",
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
});

const Home = ({
  token,
  user,
  setUser,
  isLoggedIn,
  setIsLoggedIn,
  isSuperAdmin,
  setIsSuperAdmin,
  onLogoutClick,
  triggerUseEffect,
  setUseEffect,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const [triggerUseEffect, setUseEffect] = useState(false);
  const [showGoogleSignin, setShowGoogleSignin] = useState(false);

  const onBookingFormClick = () => {
    navigate("/reservation");
  };
  const onMyReservationsClick = () => {
    navigate("/myReservations");
  };

  const handleCallbackResponse = async (response, isSuperAdmin) => {
    // console.log("Encoded JWT ID Token", response.credential);
    const userObj = jwt_decode(response.credential);
    // console.log("userObj", userObj);
    setUser(userObj);
    localStorage.setItem("userTest", JSON.stringify(userObj));
    // setTokenValue(userObj);
    setUseEffect(true);
    setIsLoggedIn(true);
    dispatch(setToken(userObj));
    navigate("/reservation");
    try {
      const ax = await ax_login(userObj);
      if (ax.code === 200 || ax.code === 201) {
        console.log(ax);
      }
    } catch (e) {
      console.log(e);
    }
    // axios
    //   .post("/api/post/login", userObj)
    //   .then((res) => {
    //     console.log(res);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };

  useEffect(() => {
    const userDataFromLocalStorage = localStorage.getItem("userTest");
    if (userDataFromLocalStorage) {
      setUser(JSON.parse(userDataFromLocalStorage));
    }
  }, [localStorage]);

  useEffect(() => {
    // localStorage.setItem("userTest", JSON.stringify(user));
  }, [user]);

  // Sets isSuperAdmin to true when "akbar.s@dyooti.com" loged in
  // useEffect(() => {
  //   isSuperAdmin === true
  //     ? toast.success("Welcome Super Admin !!")
  //     : toast.success("Welcome !!");
  //   // if (user !== "") {
  //   //   user.email === "akbar.s@dyooti.com"
  //   //     ? setIsSuperAdmin(true)
  //   //     : setIsSuperAdmin(false);
  //   // }
  // }, [isSuperAdmin]);

  // Sets isSuperAdmin to true when "akbar.s@dyooti.com" logged in

  useEffect(() => {
    if (user !== null) {
      if (
        user.email === "akbar.s@dyooti.com" ||
        user.email === "hr@dyooti.com"
      ) {
        setIsSuperAdmin(true);
        toast.success(
          <div className="flex items-center justify-center">
            Welcome
            <span
              className="mx-1 underline font-bold bg-clip-text text-transparent bg-gradient-to-r from-logo1 via-logo2 
          via-logo3 via-logo4  via-logo7 to-logo8"
            >
              {/* {user.name} */}
              Super Admin !
            </span>
            <div className="animate-skew w-fit transform transition-all ease-in-out duration-300">
              <span>❤️</span>
              {/* <span>🍆</span> */}
            </div>
          </div>,
          {
            duration: 2000,
          }
        );
      } else {
        setIsSuperAdmin(false);
        toast.success(
          <div className="flex items-center justify-center">
            Welcome{" "}
            <span
              className="underline font-bold bg-clip-text text-transparent bg-gradient-to-r from-logo1 via-logo2 
          via-logo3 via-logo4  via-logo7 to-logo8"
            >
              {user.name}
            </span>{" "}
            <div className="animate-jiggle mx-1 w-fit transform transition-all ease-in-out duration-300">
              <span>🤙</span>
              {/* <span>🍆</span> */}
            </div>
            !
          </div>,
          {
            duration: 2000,
          }
        );
      }
    }
  }, [user]);
  // console.log(user);

  useEffect(() => {
    /* global google */
    google.accounts.id.initialize({
      client_id:
        "236229986659-hn03je9sn60l06ogbkpsot1s7mqk817p.apps.googleusercontent.com",
      callback: handleCallbackResponse,
    });

    // if (token === []) {
    // google.accounts.id.renderButton(document.getElementById("signin_button"), {
    google.accounts.id.renderButton(document.getElementById("g_id_onload"), {
      theme: "outline",
      size: "large",
    });
    // console.log("Render Button");
    // setUseEffect(true);
    // }
  }, [triggerUseEffect]);

  // useEffect(() => {
  //   if (user) {
  //     setShowGoogleSignin(true);
  //   } else {
  //     setShowGoogleSignin(false);
  //   }
  // }, [triggerUseEffect]);
  // console.log("user.email:", user.email);
  // console.log("isSuperAdmin:", isSuperAdmin);
  // console.log("token:", token);
  const API_URL =
    process.env.REACT_APP_ENVIRONMENT === "dev"
      ? process.env.REACT_APP_LOCAL_API_URL
      : process.env.REACT_APP_CLOUD_API_URL;

  console.log("API_URL - " + API_URL);
  return (
    <main
      className={`h-[calc(100vh_-_56px)] flex items-center justify-center bg-primaryExtraLight2`}
      // style={{ height: "" }}
    >
      {/* <script src="https://accounts.google.com/gsi/client" async defer></script> */}
      <div className="flex-row items-center justify-center">
        <section className="font-bold text-lg sm:text-xl md:text-2xl my-2">
          Welcome to Cabins,{" "}
          <span
            className="underline bg-clip-text text-transparent bg-gradient-to-r from-logo1 via-logo2 
          via-logo3 via-logo4  via-logo7 to-logo8"
          >
            {/* Dyootian! */}
            {user ? user.name : "Dyootian!"}
            {/* {user.name} */}
          </span>{" "}
          🎉
        </section>
        {/* {isSuperAdmin === true
          ? toast.success("Welcome Super Admin !!")
          : toast.success("Welcome !!")} */}
        {/* {user && (
          <main className="m-5 flex items-center justify-center">
             <div>{user.name}</div> 
            <img
              className="rounded-full"
              src={user.picture}
              // width={30}
              // height={30}
            />
          </main>
        )} */}

        {/* {`isSuperAdmin----${JSON.stringify(isSuperAdmin)}`}
        {`isLoggedIn----${JSON.stringify(isLoggedIn)}`} */}
        {/* {JSON.stringify(token)} */}
        {/* {JSON.stringify(user)} */}
        {user !== null ? (
          <section className="flex items-center justify-center space-x-5">
            {/* <div
              onClick={onLogoutClick}
              className="w-fit flex items-center justify-center bg-primary font-bold text-secondary p-2 rounded-lg shadow-md cursor-pointer"
            >
              Logout
            </div> */}
            <div
              onClick={onBookingFormClick}
              className="w-fit flex items-center justify-center bg-primaryLight font-medium text-secondary py-1 px-2 rounded-lg shadow-md cursor-pointer"
            >
              Book a Cabin
            </div>
            <div
              onClick={onMyReservationsClick}
              className="w-fit flex items-center justify-center bg-primaryLight font-medium text-secondary py-1 px-2 rounded-lg shadow-md cursor-pointer"
            >
              My Reservations
            </div>
          </section>
        ) : (
          <section className="flex items-center justify-center">
            <div
              id="g_id_onload"
              data-client_id="236229986659-hn03je9sn60l06ogbkpsot1s7mqk817p.apps.googleusercontent.com"
              data-login_uri="https://your.domain/your_login_endpoint"
              data-auto_prompt="false"
              className="g_id_signin shadow-2xl"
              data-type="standard"
              data-size="large"
              data-theme="outline"
              data-text="sign_in_with"
              data-shape="rectangular"
              data-logo_alignment="left"
            ></div>
            <div></div>
          </section>
        )}

        {/* {showGoogleSignin ? (
          <section className="flex items-center justify-center">
            <div className="w-fit flex items-center justify-center bg-primary font-bold text-secondary p-2 rounded-lg shadow-md">
              Logout
            </div>
          </section>
        ) : (
          <section className="flex items-center justify-center">
            <div
              id="g_id_onload"
              data-client_id="236229986659-hn03je9sn60l06ogbkpsot1s7mqk817p.apps.googleusercontent.com"
              data-login_uri="https://your.domain/your_login_endpoint"
              data-auto_prompt="false"
            ></div>
            <div
              className="g_id_signin"
              data-type="standard"
              data-size="large"
              data-theme="outline"
              data-text="sign_in_with"
              data-shape="rectangular"
              data-logo_alignment="left"
            ></div>
          </section>
        )}*/}
      </div>
      {/* {token && isLoggedIn === true ? null : } */}
    </main>
  );
};

export default Home;
